import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
//import { Navigation } from "./Navigation";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
import { useUser } from "./Provider/UserProvider";
import "./Component/Asset.css";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { OrganizationMemberSelectBox } from "./Component/OrganizationMemberSelectBox";
import MemberGroupDataTable from "./Component/MemberGroupDataTable";
import { Grid } from "@mui/material";
import { OwnedGroupSelectBox } from "./Component/OwnedGroupSelectBox";
import Modal from "./Component/Modal";
import { API_DOMAIN_URL } from "./Common";

export function EditOwnedGroup() {
  const navigate = useNavigate();
  const { user } = useUser();
  const [organizationUsers, setOrganizationUsers] = useState(null);
  const [orgUser, setOrgUser] = useState();
  const [ownedGroups, setOwnedGroups] = useState();
  const [targetGroup, setTargetGroup] = useState();
  const [filterGroup, setFilterGroup] = useState("ALL");
  const [allMembers, setAllMembers] = useState([]);
  const [ownedMemberGroups, setOwnedMemberGroups] = useState([]);
  const [membersLoading, setMembersLoading] = useState(false);
  const [targetMembers, setTargetMembers] = useState([]);
  const [selectedMemberGroupNames, setSelectedMemberGroupNames] = useState([]);

  useEffect(() => {
    if (orgUser && orgUser.id) {
      getOwnedMemberGroups(orgUser);
      getOwnedGroups(orgUser);
      getOwnedMembers(orgUser);
      setFilterGroup("ALL");
      setTargetMembers([]);
      setSelectedMemberGroupNames([]);
    }
  }, [orgUser]);

  useEffect(() => {
    if (
      !targetMembers ||
      targetMembers.length === 0 ||
      ownedMemberGroups.length === 0
    ) {
      setSelectedMemberGroupNames([]);
      return;
    }
    const names = targetMembers.map((member) => {
      const groups = ownedMemberGroups.filter(
        (omg) => omg.UserId === (member.UserId || member.id)
      );
      return {
        memberName: member.NickName,
        groups: groups.map((g) => g.GroupName),
      };
    });
    setSelectedMemberGroupNames(names);
  }, [targetMembers, ownedMemberGroups]);

  const authCheck = () => {
    if (!user || !user.id || user.id == "error") {
      navigate("/SignIn");
      return false;
    }
    return true;
  };

  const getOrganizationUsers = () => {
    // get organization users data
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetOrganizationUsers?code=${code}&UserId=${user.id}`;
    //console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        //response.push(user);
        setOrganizationUsers(response);
      })
      .catch(() => {
        //console.error();
        console.log("EditOwnedGroup OrganizationUsers Exception");
        let orgUsers = [];
        orgUsers.push(user);
        setOrganizationUsers(orgUsers);
      });
  };

  const getOwnedMemberGroups = (orgUser) => {
    setMembersLoading(true);
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetUserGroupBelongings?code=${code}&UserId=${orgUser.id}`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        setOwnedMemberGroups(response);
        setMembersLoading(false);
      })
      .catch(() => {
        setOwnedMemberGroups([]);
        setMembersLoading(false);
      });
  };

  const getOwnedMembers = (orgUser) => {
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL + `/api/GetOwnedMembers?code=${code}&UserId=${orgUser.id}`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        response.push(orgUser);
        setAllMembers(response);
      })
      .catch(() => {
        setAllMembers([orgUser]);
      });
  };

  const getOwnedGroups = (orgUser) => {
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL + `/api/GetOwnedGroups?code=${code}&UserId=${orgUser.id}`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        setOwnedGroups(response);
      })
      .catch(() => {
        setOwnedGroups([]);
      });
  };

  useEffect(() => {
    if (authCheck()) {
      getOrganizationUsers();
    }
  }, []);

  // メンバーグループレコード群を更新する
  const updateOwnedMemberGroups = () => {
    if (orgUser) {
      getOwnedMemberGroups(orgUser);
      getOwnedMembers(orgUser);
    }
  };

  // 表示行の計算（1メンバー1行）
  const computeDisplayRows = () => {
    if (ownedMemberGroups.length === 0) return [];

    if (filterGroup === "ALL") {
      if (allMembers.length === 0) return [];
      return allMembers.map((member) => {
        const groups = ownedMemberGroups.filter(
          (omg) => omg.UserId === member.id
        );
        return {
          id: member.id,
          UserId: member.id,
          NickName: member.NickName,
          GroupName: groups.map((g) => g.GroupName).join("、"),
          Furigana: member.Furigana,
          Sex: member.Sex,
          Birthday: member.Birthday,
          BodyHeight: member.BodyHeight,
          BodyWeight: member.BodyWeight,
          Prefecture: member.Prefecture,
        };
      });
    } else {
      const filtered = ownedMemberGroups.filter(
        (omg) => omg.GroupId === filterGroup.id
      );
      const seen = new Set();
      return filtered
        .filter((omg) => {
          if (seen.has(omg.UserId)) return false;
          seen.add(omg.UserId);
          return true;
        })
        .map((omg) => ({
          id: omg.UserId,
          UserId: omg.UserId,
          NickName: omg.NickName,
          GroupName: omg.GroupName,
          Furigana: omg.Furigana,
          Sex: omg.Sex,
          Birthday: omg.Birthday,
          BodyHeight: omg.BodyHeight,
          BodyWeight: omg.BodyWeight,
          Prefecture: omg.Prefecture,
        }));
    }
  };

  const displayRows = computeDisplayRows();

  // グループに追加処理
  const updateClicked = () => {
    if (!targetMembers || targetMembers.length === 0) {
      errorModalOpen("メンバー追加", "追加するメンバーを選択してください");
      return;
    } else if (!targetGroup) {
      errorModalOpen("メンバー追加", "追加先のグループを選択してください");
      return;
    }

    // 追加対象に指定しているグループに、既に所属している場合はキャンセル
    let hit = false;
    targetMembers.forEach((tMem) => {
      ownedMemberGroups.forEach((oMemGrp) => {
        if (
          tMem.UserId == oMemGrp.UserId &&
          targetGroup.id == oMemGrp.GroupId
        ) {
          hit = true;
        }
      });
    });
    if (hit) {
      errorModalOpen("メンバー追加", "指定のグループには既に追加されています");
      return;
    }

    let bodyObj = {};
    bodyObj.GroupId = targetGroup.id;
    let userIdAry = targetMembers.map((m) => m.UserId);
    userIdAry = userIdAry.filter((x, i, self) => self.indexOf(x) === i);
    bodyObj.UserIds = userIdAry;

    const bodyString = JSON.stringify(bodyObj);
    const code = process.env.REACT_APP_API_CODE;
    let url = API_DOMAIN_URL + `/api/ConnectUsersToTargetGroup?code=${code}`;

    fetch(url, {
      method: "POST",
      body: bodyString,
    }).then(
      function (response) {
        if (response.status == 200) {
          successModalOpen(
            "メンバー追加",
            "メンバーを指定のグループに追加しました"
          );
        } else if (response.status == 204 || response.status == 400) {
          errorModalOpen("メンバー追加", "メンバーの追加に失敗しました");
        }
      },
      function (error) {
        console.log(error);
      }
    );
  };

  // 行の削除ボタンから単一メンバーを削除
  const deleteMemberFromGroup = (member) => {
    if (filterGroup === "ALL") return;

    const groupCount = ownedMemberGroups.filter(
      (omg) => omg.UserId === member.UserId
    ).length;
    if (groupCount <= 1) {
      errorModalOpen(
        "メンバー除外失敗",
        `${member.NickName}は所属グループが１つしか無い為、削除出来ません`
      );
      return;
    }

    const relationsToDelete = [];
    ownedMemberGroups.forEach((omg) => {
      if (omg.UserId === member.UserId && omg.GroupId === filterGroup.id) {
        relationsToDelete.push(omg.id);
      }
    });

    let bodyObj = {};
    bodyObj.UserGroupRelationIds = relationsToDelete;

    const bodyString = JSON.stringify(bodyObj);
    const code = process.env.REACT_APP_API_CODE;
    let url = API_DOMAIN_URL + `/api/DeleteUserGroupRelation?code=${code}`;

    fetch(url, {
      method: "POST",
      body: bodyString,
    }).then(
      function (response) {
        if (response.status == 200) {
          successModalOpen(
            "メンバー除外",
            "選択したグループからメンバーを除外しました"
          );
        } else if (response.status == 204 || response.status == 400) {
          errorModalOpen("メンバー除外", "メンバーの除外に失敗しました");
        }
      },
      function (error) {
        console.log(error);
      }
    );
  };

  // 更新完了確認のモーダル
  const [successModalStatus, setSuccessModalStatus] = React.useState(false);
  const [successTitle, setSuccessTitle] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const successModalOpen = (title, message) => {
    setSuccessTitle(title);
    setSuccessMessage(message);
    setSuccessModalStatus(true);
  };
  const successModalClose = () => {
    setSuccessModalStatus(false);
    updateOwnedMemberGroups(); //DBから再取得してDataGridを更新
  };

  // エラーモーダル
  const [errorModalStatus, setErrorModalStatus] = React.useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const errorModalOpen = (title, message) => {
    setErrorTitle(title);
    setErrorMessage(message);
    setErrorModalStatus(true);
  };
  const errorModalClose = () => {
    setErrorModalStatus(false);
  };

  return (
    <div className="asset-list-root">
      <AccountMenu />
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item md={4}>
              <Typography component="h1" variant="h5">
                所属グループ編集
              </Typography>
            </Grid>
            <Grid item md={8}></Grid>

            <Grid item md={3} mt={1}>
              <OrganizationMemberSelectBox
                orgUsers={organizationUsers}
                setOrgUser={setOrgUser}
              />
            </Grid>
            <Grid item md={9} mt={1}></Grid>

            <Grid item xs={12} mt={1}>
              <FormControl sx={{ m: 1, minWidth: 200, maxWidth: 500 }}>
                <InputLabel>
                  {orgUser && !ownedGroups ? "読み込み中..." : "グループで絞込"}
                </InputLabel>
                <Select
                  label="グループで絞込"
                  value={
                    filterGroup === "ALL" ? "ALL" : filterGroup?.id || "ALL"
                  }
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val === "ALL") {
                      setFilterGroup("ALL");
                    } else {
                      const grp = ownedGroups.find((g) => g.id === val);
                      setFilterGroup(grp || "ALL");
                    }
                    setTargetMembers([]);
                  }}
                  size="small"
                  disabled={!orgUser || !ownedGroups}
                >
                  <MenuItem value="ALL">全メンバー</MenuItem>
                  {ownedGroups &&
                    ownedGroups.map((group, i) => (
                      <MenuItem value={group.id} key={i}>
                        {group.Name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <MemberGroupDataTable
            members={displayRows}
            setTargetMembers={setTargetMembers}
            filterGroup={filterGroup}
            onDeleteMember={deleteMemberFromGroup}
            loading={membersLoading}
          />

          <Box
            sx={{
              width: "100%",
              mt: 1,
              mb: 1,
              height: 80,
              overflowY: "auto",
              border: "1px solid #ccc",
              borderRadius: 1,
              p: 1,
            }}
          >
            {selectedMemberGroupNames.map((item, i) => (
              <Typography key={i} variant="body2">
                {item.memberName} の所属グループ：
                {item.groups.length > 0 ? item.groups.join("、") : "なし"}
              </Typography>
            ))}
          </Box>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item md={12} sx={{ mt: 2 }}>
              <Typography variant="body2">
                選択したメンバーを以下のグループに追加
              </Typography>
            </Grid>
            <Grid item md={5}>
              <OwnedGroupSelectBox
                ownedGroups={ownedGroups}
                setTargetGroup={setTargetGroup}
              />
            </Grid>
            <Grid item md={4}>
              <Button
                variant="contained"
                color="success"
                sx={{ pr: "50px", pl: "50px" }}
                onClick={() => updateClicked()}
              >
                追加
              </Button>
            </Grid>
            <Grid item md={3}></Grid>
          </Grid>
          <Box sx={{ mb: 6 }} />
        </Box>
      </Container>
      <Modal
        title={errorTitle}
        message={errorMessage}
        status={errorModalStatus}
        okBtnCallback={errorModalClose}
      />
      <Modal
        title={successTitle}
        message={successMessage}
        status={successModalStatus}
        okBtnCallback={successModalClose}
      />
    </div>
  );
}
